/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export const ARTWORK_SIZES = ({
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
} as const);
export const SHAPE = ({
  DEFAULT: 'DEFAULT',
  ROUND: 'ROUND'
} as const);